import { TrendingDown } from "@material-ui/icons";
import { memo } from "react";

const { Typography, Grid } = require("@material-ui/core");
const {
  default: MaskService,
} = require("../../../../../utils/mask/maskService");

const LossTotalRow = ({ total, isFinal }) => {
  const spacing = isFinal ? 16 : 8;

  return (
    <Grid
      container
      direction="row"
      style={{
        padding: spacing,
        gap: spacing,
        maxWidth: "100%",
        backgroundColor: "#ffcccb ",
      }}
    >
      <Grid item>
        <TrendingDown style={{ color: "red" }} fontSize="medium" />
      </Grid>
      <Grid item xs>
        <Typography
          style={{
            color: "red",
            fontWeight: "bold",
          }}
        >
          {isFinal ? "Resultado: " : "Prejuízo: "}
        </Typography>
      </Grid>
      <Grid item>
        <Typography
          style={{
            color: "red",
            fontWeight: "bold",
          }}
        >{`- R$ ${MaskService.toMask(
          "decimal",
          parseFloat(total).toFixed(2),
          2
        )}`}</Typography>
      </Grid>
    </Grid>
  );
};

export default memo(LossTotalRow);
